import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './EditableMenu.css';

const EditableMenu = () => {
  const initialMenu = [];
  const [menu, setMenu] = useState(initialMenu);
  const [isNextWeek, setIsNextWeek] = useState(false); // State to track current/next week
  const navigate = useNavigate();

  useEffect(() => {
    fetchMenu();
  }, [isNextWeek]); // Refetch menu when isNextWeek changes

  const fetchMenu = async () => {
    const menuUrl = isNextWeek ? '/menu1.php' : '/menu.php'; // Change URL based on the week
    try {
      const response = await fetch(menuUrl);
      const data = await response.json();
      setMenu(data);
    } catch (error) {
      console.error('Chyba při načítání menu:', error);
    }
  };

  const handleSave = async () => {
    const menuUrl = isNextWeek ? '/menu1.php' : '/menu.php'; // Save to the correct file
    try {
      const response = await fetch(menuUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(menu),
      });
      const data = await response.json();
      alert(data.message);
    } catch (error) {
      console.error('Chyba při ukládání menu:', error);
      alert('Chyba při ukládání menu.');
    }
  };

  const handleChange = (index, field, value) => {
    const updatedMenu = menu.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setMenu(updatedMenu);
  };

  const handleAddRow = () => {
    const updatedMenu = [...menu, { name: '' }];
    setMenu(updatedMenu);
  };

  const handleAddHeaderRow = () => {
    const updatedMenu = [...menu, { header: true, name: '' }];
    setMenu(updatedMenu);
  };

  const handleAddNoteRow = () => {
    const updatedMenu = [...menu, { note: true, content: '' }];
    setMenu(updatedMenu);
  };

  const handleDeleteRow = (index) => {
    if (window.confirm("Opravdu chcete smazat řádek?")) {
      const updatedMenu = menu.filter((_, i) => i !== index);
      setMenu(updatedMenu);
    }
  };

  const handlePrint = () => {
    navigate('/print');
  };

  const handleBack = () => {
    navigate('/majitel');
  };

  const copyToCurrentWeek = async () => {
    try {
      const response = await fetch('/copyMenu.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ source: 'menu1.json', target: 'menu.json' }),
      });
      const data = await response.json();
      alert(data.message);
      setIsNextWeek(false); // Switch back to current week after copy
    } catch (error) {
      console.error('Chyba při kopírování menu:', error);
      alert('Chyba při kopírování menu.');
    }
  };

  return (
    <div className="editable-menu">
      <button
        className="mb-4 bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600"
        onClick={handleBack}
      >
        Zpět
      </button>

      {/* Buttons to switch between weeks */}
      <div className="week-switcher mb-4">
        <button
          className={`mr-2 ${!isNextWeek ? 'bg-blue-500' : 'bg-gray-500'} text-white py-2 px-4 rounded`}
          onClick={() => setIsNextWeek(false)}
        >
          Aktuální týden
        </button>
        <button
          className={`${isNextWeek ? 'bg-blue-500' : 'bg-gray-500'} text-white py-2 px-4 rounded`}
          onClick={() => setIsNextWeek(true)}
        >
          Následující týden
        </button>
      </div>

      <h2>Úprava týdenního menu</h2>
      <div className="menu-content">
        <table>
          <thead>
            <tr>
              <th style={{ width: '90%' }}>Název jídla</th>
              <th style={{ width: '10%' }}></th>
            </tr>
          </thead>
          <tbody>
            {menu.map((item, index) => (
              <tr key={index}>
                {item.header ? (
                  <>
                    <td colSpan="2">
                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) => handleChange(index, 'name', e.target.value)}
                        placeholder="Nadpis"
                      />
                    </td>
                    <td>
                      <button
                        className="delete-button"
                        onClick={() => handleDeleteRow(index)}
                      >
                        ✖
                      </button>
                    </td>
                  </>
                ) : item.note ? (
                  <>
                    <td colSpan="2">
                      <input
                        type="text"
                        value={item.content}
                        onChange={(e) => handleChange(index, 'content', e.target.value)}
                        placeholder="Poznámka"
                      />
                    </td>
                    <td>
                      <button
                        className="delete-button"
                        onClick={() => handleDeleteRow(index)}
                      >
                        ✖
                      </button>
                    </td>
                  </>
                ) : (
                  <>
                    <td>
                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) => handleChange(index, 'name', e.target.value)}
                        placeholder="Název jídla"
                      />
                    </td>
                    <td>
                      <button
                        className="delete-button"
                        onClick={() => handleDeleteRow(index)}
                      >
                        ✖
                      </button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        <button onClick={handleAddRow}>Přidat řádek</button>
        <button onClick={handleAddHeaderRow}>Přidat nadpis</button>
        <button onClick={handleAddNoteRow}>Přidat poznámku</button>
      </div>
      <button onClick={handleSave}>Uložit menu</button>
      <button onClick={handlePrint}>Tisk</button>

      {/* Button to copy next week's menu to current */}
      {isNextWeek && (
        <button
          className="mt-4 bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
          onClick={copyToCurrentWeek}
        >
          Přehodit na aktuální týden
        </button>
      )}
    </div>
  );
};

export default EditableMenu;